<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Transactions",
          icon: "bi bi-arrow-left-right",
          route: "transactions-index",
        },
        {
          label: "Nouvelle transaction",
          icon: "bi bi-plus-circle-fill",
          route: "transactions-create",
        },
      ],
    };
  },
};
</script>
